<template>
   <div>
        <Step1 @close="close" @remove="remove" v-if="step1" :phone="phone"/>
        <Step2 @endNumber="endNumber" @remove="remove" :phoneNumber="phoneNumber" v-if="step2"/>
        <transition name="fade">
            <Success :successMessage="successMessage" v-if="successModal" @hideSuccessMessage="hideSuccessMessage"></Success>
        </transition>
   </div>
</template>

<script>
import Step1 from './numberstep1';
import Step2 from './numberstep2';
import Success from '@/views/plugin/success'

export default {
        props:['phone','isIdPhoneUpdated'],
        data(){
            return{
                step1:false,
                step2:false,
                phoneNumber:'',
                successMessage:'',
                successModal:false,
            }
        },
        methods:{
            hideSuccessMessage(){
                this.successMessage = '',
                this.successModal = false;
            },
            close(value){
                this.step1 = false;
                this.step2 = true;
                this.phoneNumber = value;
            },
            remove(){
                this.step1 = false;
                this.step2 = false;
            },
            checkPhone(){
                this.step1 = true;
            },
            endNumber(){
                this.step2 = false;
                this.$emit('setNumber',this.phoneNumber);
                this.successMessage = 'Амжилттай баталгаажлаа ';
                this.successModal = true;
            }
        },
        created(){
            this.checkPhone();
        },
        components:{
            Step1,
            Step2,
            Success
        }
}
</script>
<style>
.number-modal{
    position: fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:5000;
    background: rgba(0,0,0,0.5);
}
.number-modal-body{
    z-index:5000;
    position: absolute;
    width: 436px;
    height: auto;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
}
.number-close{
    padding-left: 54px;
    margin-top:30px;
    padding-right: 30px;
    width:100%;
    display: flex;
    justify-content: flex-end;
}
.number-close img{
    width:20px;
    height: 20px;
    cursor: pointer;
}
.number-body{
    margin-top:49px;
}
.number-body-title{
    padding-left: 54px;
    width:100%;
}
.number-body-title p{
    margin-bottom:0;
    font-size: 20px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
}
.number-body-form{
    padding-left: 54px;
    width:100%;
    margin-top:29px;
}
.number-body-form form{
    padding-right: 53px;
    display: flex;
    flex-direction: column;
}
.number-body-form form input[type=text]{
     border-radius: 5px;
     height: 37px;
    background-color: #ebebeb;
    outline: none;
    border:none;
    font-size:11px;
    padding-left: 15px;
}
.number-body-form form input[type=text]::placeholder{
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 4.09;
    letter-spacing: 0.3px;
    text-align: left;
    color: rgba(0, 0, 0, 0.5);
}
.number-body-form form input[type=submit]{
    margin-top:19px;
    width: 50%;
    height: 38px;
    border-radius: 5px;
    background-color: #1660ab;
    outline: none;
    border: none;
    font-size: 13px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.3px;
    color: #ffffff;
    cursor: pointer;
}
.someSpace{
    margin-top:2px!important;
}
.number-footer{
    margin-top:50px;
    height: 103px;
    width:100%;
    background-color: #1660ab;
    display: flex;
    align-items: center;
}
.number-footer p{
    padding-left: 53px;
    padding-right: 55px;
    margin-bottom:0;
    font-size: 12.1px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.49;
    text-align: center;
    letter-spacing: normal;
    color: rgba(255, 255, 255, 0.8);
}
.number-error{
    width:100%;
    height: auto;
}
.number-error p{
    margin-bottom:0;
    font-size:11px;
    color:#ed3237;
}
@media screen and (max-width: 500px) {
    .number-modal-body{
        height: auto;
    }
    .number-close{
        margin-top:20px;
        padding-right: 15px;
    }
   .number-close img{
       width:15px;
       height: 15px;
    }
    .number-body{
        margin-top:20px;
    }
    .number-body-title,.number-body-form{
        padding-left: 20px;
    }
    .number-body-title{
        padding-right: 20px;
    }
    .number-body-title p{
        font-size:18px;
    }
    .number-body-form{
        margin-top:10px;
    }
    .number-footer p{
        padding-left: 10px;
        padding-right: 10px;
        font-size:10px;
    }
    .number-body-form form{
        padding-right: 20px;
    }   
    .number-body-form form input[type=submit]{
        height: 30px;
        width:100%;
        display: flex;
        justify-content: center;
        font-size:11px;
    }
    .number-body-form form input[type=text]{
        padding-left: 10px;
        padding-right: 10px;
    }
    .number-footer{
        height: 80px;
    }
}
@media screen and (max-width: 800px) {
    .number-modal-body{
      width:80%;
    }
    .number-body-form form input[type=submit]{
        width:auto;
    }
    .number-body-title {
        padding-right: 53px;
    }
}
</style>